import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-backtoadmin',
    templateUrl: './backtoadmin.component.html',
    styleUrls: ['./backtoadmin.component.less'],
    standalone: false
})
export class BacktoadminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  fireOptions() {
    Swal.fire({
      title: "Gestao de Marcas",
      html: '<div class="row"><div class="col-12"><a class="px-4 py-2 btn-grad rounded duration-500" href="admin/gestaoMarcas/alta?marca=true">Gerir Alta Relojoaria</a>'+
            '<a class="px-4 py-2 btn-grad rounded duration-500" href="admin/gestaoMarcas/pratas?marca=true">Gerir Pratas</a></div>'+
            '<div class="col-12 mt-4"><a class="px-4 py-2 btn-grad rounded duration-500" href="admin/gestaoMarcas/relojoaria?marca=true">Gerir Relojoaria</a>'+
            '<a class="px-4 py-2 btn-grad rounded duration-500" href="admin/gestaoMarcas/joias?marca=true">Gerir Joalharia</a></div>'+
            '<div class="col-12 mt-4"><a class="px-4 py-2 btn-grad rounded duration-500" href="admin/gestaoMarcas/noivas?marca=true">Gerir Noivas</a>'+
            '<a class="px-4 py-2 btn-grad rounded duration-500" href="admin/gestaoMarcas/acessorios?marca=true">Gerir Acessórios</a></div></div>',
      icon: 'question',
      showCancelButton: false,
      showConfirmButton: false,
      customClass: {
        htmlContainer: "moreHeight"
      }
    });
  }
}
